export default __webpack_public_path__ + "images/WH.6fa7fa3.png";